import React from 'react';
import { CssStyleProps } from 'src/base/props/CssStyleProps';
import { Text } from 'src/base/texts/Text';

export const H1: React.FC<CssStyleProps> = ({ style, children }) => (
  <Text variant="h1" style={style}>
    {children}
  </Text>
);
